module.exports = function(bootstrap) {
    "use strict";
    bootstrap.directive('detailsMap', function(){
        return {
            replace: true,
            scope: {
                details: "=",
                ready: "=",
                coreMetricsConfig: "="   //for coremetrics
            },
            template: require('articles/providers/detailsMap/detailsMap.html'),
            controller: ['$scope', '$state', 'sessionData', 'teamsite','$q', 'parseProviderDetails',
                function($scope, $state, sessionData, teamsite, $q, parseProviderDetails) {
                    window.$scope = $scope;

                    var details = $scope.details || {},

                        checkKey = function (key) {
                            return !!(sessionData && sessionData.appConfig && sessionData.appConfig.PROVIDER && sessionData.appConfig.PROVIDER[key] && sessionData.appConfig.PROVIDER[key].booleanValue);
                        };

        $q.all({
            'id1': teamsite.get("PVD_SITE_OF_SERVICE_TOOLTIPLAB"),
            'id2': teamsite.get("PVD_SITE_OF_SERVICE_TOOLTIP_XRAY"),
            'id3': teamsite.get("PVD_SITE_OF_SERVICE_TOOLTIP_SURGICAL")
            // 'id3': teamsite.get("PVD_SearchResults_CheckPlanIconText")
        }).then(function(content) {
            var str = '';
            if ( $scope.selectedLocation && $scope.selectedLocation.specialties &&  $scope.selectedLocation.specialties.length>0) {
                for (var i = 0; i <  $scope.selectedLocation.specialties.length; i++) {
                    str = $scope.selectedLocation.specialties[i].replace(/\s/g, '');

                    if (str.indexOf("IndependentLaboratory") > -1) {
                        $scope.tooltip_siteOfService = content.id1;
                        return;
                    }
                    else if (str.indexOf("X-ray/ImagingCenter") > -1) {
                        $scope.tooltip_siteOfService = content.id2;
                        return;
                    }
                    else if (str.indexOf("AmbulatorySurgicalCenter") > -1) {
                        $scope.tooltip_siteOfService = content.id3;
                        return;
                    }
                }
            }

        });
                    $scope.appConfig = (sessionData && sessionData.appConfig && sessionData.appConfig.PROVIDER) ? sessionData.appConfig.PROVIDER : settings.setupDefaultAppConfig();


                    $scope.map = {};

                    $scope.features = parseProviderDetails.filterFeatures(details.selectedLocation.features);

                    $scope.ahnAffiliated = !!($scope.features.ahnFacility === "TRUE" ||
                        $scope.features.ahnPractitioner === "TRUE" ||
                        $scope.features.ahnPractice === "TRUE");

                    $scope.hideMaps = sessionData && sessionData.appConfig && sessionData.appConfig.PROVIDER &&
                        sessionData.appConfig.PROVIDER[$scope.coreMetricsConfig.subApp + '_HIDE_MAPS'] &&
                        sessionData.appConfig.PROVIDER[$scope.coreMetricsConfig.subApp + '_HIDE_MAPS'].booleanValue;

                    $scope.hideNetwork = sessionData && sessionData.appConfig && sessionData.appConfig.PROVIDER &&
                        sessionData.appConfig.PROVIDER[$scope.coreMetricsConfig.subApp + '_HIDE_NETWORK'] &&
                        sessionData.appConfig.PROVIDER[$scope.coreMetricsConfig.subApp + '_HIDE_NETWORK'].booleanValue;

                    $scope.displayPlanNotice = !$state.params.productId && sessionData && sessionData.appConfig && sessionData.appConfig.PROVIDER &&
                        sessionData.appConfig.PROVIDER[$scope.coreMetricsConfig.subApp + '_ENABLE_PLANNOTICE'] &&
                        sessionData.appConfig.PROVIDER[$scope.coreMetricsConfig.subApp + '_ENABLE_PLANNOTICE'].booleanValue;

                    $scope.isHospital = details.selectedLocation.hospital;

                    $scope.productId = $state.params.productId;
                    $scope.inNetwork = !!(details.inNetwork);

                    $scope.phones = details.selectedLocation.phoneNumber;

                    $scope.markers = angular.copy([details.selectedLocation.address]);
                    for (var x=0;x<$scope.markers.length;x++) {
                        delete $scope.markers[x].address3;
                    }

                    $scope.markers[0].latLng = parseProviderDetails.transformLatLng($scope.markers[0].latLng || $scope.markers[0].latlng);

                    $scope.professionalInfo = details.professionalInfo || {};
                    $scope.selectedLocation = details.selectedLocation;
                    $scope.medicareContent="This provider has admitting privileges to a Medicare affiliated hospital";
                    $scope.displayUrl = "Visit the Website";
                    teamsite.get('PVD_NOT_ACCEPTING_NEW_PATIENTS').then(function (res) {
                        $scope.notAcceptingNewPatients = res;
                    });
                    $scope.restrictionFlagsCode = ["0001","0002","0003","0004","0005"];
                    $scope.restrictionFlagsList = [];
                    $scope.designationCodeList = [];
                    teamsite.get('PVD_RESTRICTION_FLAGS').then(function (res) {
                        $scope.restrictionFlags = JSON.parse(res);

                        var object = $scope.restrictionFlags.restriction;
                        for (var i = 0; i < object.length; i++) {
                            angular.forEach(object[i], function (val, key) {
                                if ( $scope.details.restrictionFlagsList.indexOf(key) > -1) {
                                    if ($scope.restrictionFlagsList.indexOf(val) === -1) {
                                        $scope.restrictionFlagsList.push(val);
                                    }
                                    return;


                                }
                                if ($scope.details.designationCodeList.indexOf(key) > -1 ) {

                                    if ($scope.designationCodeList.indexOf(val) === -1) {
                                        $scope.designationCodeList.push(val);
                                        console.log("designation code",$scope.designationCodeList)

                                    }

                                    return;

                                }

                            });


                        }

                    });



                    //getting current date
                    $scope.details.vbidIndicator = $scope.details.valueBasedIndicator;
                    $scope.details.designationCodeList = ($scope.details.designationCodes && $scope.details.designationCodes.length > 0) ? $scope.details.designationCodes : "" ;
                    $scope.details.restrictionFlagsList = ($scope.details.restrictionFlags  && $scope.details.restrictionFlags .length > 0) ? $scope.details.restrictionFlags  : "" ;
                    $scope.details.currentDate = new Date();
                    $scope.details.formDate= $scope.details.currentDate.getFullYear() +  ('0' + ($scope.details.currentDate.getMonth() + 1)).slice(-2) +  ('0' + $scope.details.currentDate.getDate()).slice(-2);

                    $scope.details.effDate = new Date($scope.details.vbidEffectiveDate);
                    $scope.details.vbidEffDate= $scope.details.effDate.getFullYear() +  ('0' + ($scope.details.effDate.getMonth() + 1)).slice(-2) +  ('0' + $scope.details.effDate.getDate()).slice(-2);

                    $scope.details.terDate = new Date($scope.details.vbidTerminationDate);
                    $scope.details.vbidTerDate= $scope.details.terDate.getFullYear() +  ('0' + ($scope.details.terDate.getMonth() + 1)).slice(-2) +  ('0' + $scope.details.terDate.getDate()).slice(-2);


                    //Scheduling is only for AHN
                    $scope.displayScheduleBtn = $scope.professionalInfo && $scope.professionalInfo.webEnabled === true && checkKey($scope.coreMetricsConfig.subApp + '_ENABLE_SCHEDULING');

                    $scope.websiteUrl = function () {
                        var url;

                        if ($scope.professionalInfo && $scope.professionalInfo.websiteUrl) {
                            url = $scope.professionalInfo.websiteUrl;
                        } else if ($scope.selectedLocation && $scope.selectedLocation.websiteUrl) {
                            url = $scope.selectedLocation.websiteUrl;
                        } else {
                            return '';
                        }

                        if (url.substring(0, 7) === 'http://') {
                            return url.substring(7);
                        } else if (url.substring(0, 8) === 'https://') {
                            return url.substring(8);
                        } else {
                            return url;
                        }
                    }();

                    $scope.acceptingNewPatients = $scope.features.acceptingNewPatients;
                    $scope.pcpEligible = $scope.features.pcpEligible;
                    $scope.homeHealthProvider = $scope.features.homeHealthProvider;
                    $scope.siteOfService = function () {
                        if ($scope.appConfig &&
                            $scope.appConfig.PVD_ENABLE_SITEOFSERVICE &&
                            $scope.appConfig.PVD_ENABLE_SITEOFSERVICE.booleanValue ) {
                            var siteOfService = $scope.features.siteOfService  || "";
                            return !!(siteOfService === 'TRUE' || siteOfService === true);
                        }
                    }();


                    $scope.goToScheduling = function () {
                        $state.go('scheduling', {
                            displayName: details.professionalInfo.displayName ||details.selectedLocation.displayName
                        });
                    };

                }]
        };
    });
};
